import eventListeners from './event-listeners';
import selectionChangeHandler from '../handlers/selection-change-handler';

const selectionChangeListener = (element) => {
  eventListeners.add(element, 'selectionchange', selectionChangeHandler);
};

export default selectionChangeListener;
